<div class="bg-white">
    <div class="flex items-center border-b border-solid bg-white p-5">
        <button
            class="sr-app-light:absolute h-5 w-5"
            [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
            (click)="redirectToBack()">
            <mat-icon class="dark:filter-yellow" svgIcon="back-arrow"></mat-icon>
        </button>

        <div class="align-center flex flex-1 items-center justify-center">
            <h1 class="vl-app-light:font-bold mx-1 text-base font-semibold">
                {{
                    this.env.EXPLORE?.ORIGINAL_ROUTE_NAME
                        ? currentRouteGroup?.name
                        : (currentRouteGroup?.name | translate)
                }}
            </h1>
        </div>
    </div>
    <rwidget-explore-routes *ngIf="currentRouteGroup" [routes]="currentRouteGroup?.routes"></rwidget-explore-routes>
</div>
